const inputViewNew = {
  placeholder: 'Escreva aqui...'
};

export default inputViewNew;
